// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"545e9255e25b554b4b1f","780":"e350c0141a5e4cabacb9","838":"302546d453826d96ab04"}[chunkId] + ".js";
};